import {Matcher} from '@/lib/axiosAddTransforms'
import {
  offsetResponse,
  transactionDateResponse,
} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/notice\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        payload.url = '/notifications/service-notice'
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return {}
        }
        return {
          results: data.results.map((result) => noticeResponse(result)),
          ...propertyResponse(data),
        }
      },
    },
  },
]

const noticeResponse = (data) => {
  const {id, contents, title, noticedAt, theme} = data
  const color = 'exclamation' === theme ? 'danger': 'gray-900'
  return {
    id: String(id),
    title,
    noticedAt: transactionDateResponse(noticedAt),
    contents,
    theme,
    color
  }
}

const propertyResponse = (data) => {
  const {next, count} = data
  return {
    nextOffset: offsetResponse(next),
    count,
  }
}

export default matchers
